import React, { useContext, useCallback } from 'react'
import { IChannel } from 'shared/types/channel'
import AddToButton from './add-to-button'
import ChannelList from './channel-list'
import EmptyCollectionCTA from './empty-collection-cta'
import ModalContext from 'shared/components/context/modal'
import { CollectionContext } from 'shared/components/context/add-to-collections-manager'
import { AddToCollectionPlus, AddToSection, AddToCollectionContainer, AddToCollectionText } from './sc'
import { Grid } from '@giphy/react-components'
import { useChannelWithNormalGifFetch } from 'shared/api/channels'
import { isEmpty } from 'lodash'

export function flatten(children: IChannel[]) {
    const flat: IChannel[] = [...children]
    children.forEach(channel => {
        if (channel.children) {
            flat.push(...flatten(channel.children))
        }
    })
    return flat
}

const empty = {} as IChannel
type Props = {
    onAdd: (channelId: number, searchChannelId: number) => void
}

const ChannelsGif = ({ channelId }: { channelId: number }) => {
    const { gif } = useContext(CollectionContext)
    const fetchGifs = useChannelWithNormalGifFetch(channelId, 'gifs')

    return <Grid fetchGifs={fetchGifs} gutter={10} width={gif ? 480 : 968} columns={3} />
}

const AddToCollection = ({ onAdd }: Props) => {
    const {
        activeChannelId,
        addGifsToCollectionSuccessMessage,
        activeChannelColor,
        gif,
        channels,
        rootChannelId,
    } = useContext(CollectionContext)
    const rootChannel = channels[rootChannelId]
    const { openNewCollectionPanel } = useContext(ModalContext)
    const findChannel = (id: number | undefined) => (id ? channels[id] || empty : empty)
    const activeChannel = findChannel(activeChannelId)

    const CallbackChannelsGif = useCallback(() => {
        return <ChannelsGif channelId={activeChannel.id} />
    }, [activeChannelId, addGifsToCollectionSuccessMessage])

    const showEmptyCta = () => {
        if (!!activeChannel && !isEmpty(activeChannel)) {
            const { has_children, parent } = activeChannel
            if (!has_children && !parent) {
                return true
            } else {
                return false
            }
        }
    }
    return (
        <>
            {!showEmptyCta() ? (
                <>
                    {activeChannelId ? (
                        <ChannelList
                            addButton={
                                <AddToButton
                                    displayName={'New sub-collection'}
                                    onClick={() =>
                                        openNewCollectionPanel({
                                            parentChannel: activeChannel,
                                            userId: rootChannel.user?.id,
                                            gif,
                                        })
                                    }
                                    backgroundText={activeChannelColor}
                                />
                            }
                            onClick={(collectionId: number) => {
                                onAdd(collectionId, rootChannelId)
                            }}
                            channel={activeChannel}
                            isRoot={false}
                        />
                    ) : (
                        <ChannelList
                            addButton={
                                <AddToButton
                                    displayName={'New collection'}
                                    onClick={() =>
                                        openNewCollectionPanel({
                                            parentChannel: rootChannel,
                                            userId: rootChannel.user?.id,
                                            gif,
                                        })
                                    }
                                    backgroundText="#3e3e3e"
                                />
                            }
                            channel={rootChannel}
                            onClick={(collectionId: number) => {
                                onAdd(collectionId, rootChannelId)
                            }}
                            isRoot={true}
                        />
                    )}
                    {activeChannelId && !!activeChannel.parent && (
                        <>
                            <AddToSection>
                                <AddToCollectionContainer onClick={() => onAdd(activeChannelId, rootChannelId)}>
                                    <AddToCollectionPlus />
                                    <AddToCollectionText>
                                        Add to <b>{activeChannel.display_name}</b>
                                    </AddToCollectionText>
                                </AddToCollectionContainer>
                            </AddToSection>
                            <CallbackChannelsGif />
                        </>
                    )}
                </>
            ) : (
                <EmptyCollectionCTA channel={activeChannel} />
            )}
        </>
    )
}
export default AddToCollection
